import React from "react";
import './WhoWeServe.css';

export default function WhoWeServe() {
    const industries = [
        { id: 1, industries: "Retail", 
          Description: "We specialise in printing services for retail, creating vibrant showroom print collaterals, promotional materials, and durable shopping bag printing. Our solutions ensure your brand attracts attention and leaves a lasting impression on customers.",
          link: "/retail-printing" }, // Add link for each industry
        { id: 2, industries: "Education",
          Description: "Empowering educational institutions with education printing services, such as brochures, certificates, and customised stationery. Whether for schools or colleges, our prints enhance branding and communication effectively.",
          link: "/printing-for-education" },
        { id: 3, industries: "Corporate",
          Description: "Delivering premium corporate printing solutions for business cards, letterheads, and event materials. Our high-quality prints help businesses make a professional and lasting impact on their stakeholders.",
          link: "/document-printing-and-binding" },
        { id: 4, industries: "Healthcare",
          Description: "Providing tailored healthcare printing services, including patient forms, prescription pads, and informational brochures. Our solutions meet the specific needs of clinics, hospitals, and healthcare organisations.",
          link: "#" },
        { id: 5, industries: "Hospitality",
          Description: "Offering hospitality printing solutions such as menu cards, signage, and guest brochures. Our high-quality prints enhance guest experiences and promote your brand effectively.",
          link: "/restaurants-printing" },
        { id: 6, industries: "Events & Entertainment",
          Description: "We specialise in printing for events and festivals, including banners, posters, and invitations. From concerts to corporate events, our creative solutions make every occasion memorable.",
          link: "/events-and-festivals" },
        { id: 7, industries: "Real Estate",
          Description: "Supporting real estate businesses with real estate printing services like brochures, signage, and promotional materials. Our solutions showcase properties and help build trust with clients.",
          link: "/realestate-printing" },
        { id: 8, industries: "Exhibitions",
          Description: "Providing impactful exhibition printing solutions, including standees, banners, and leaflets. Our high-quality visuals attract visitors and elevate your brand presence at events.",
          link: "#" },
        { id: 9, industries: "Ecommerce",
          Description: "Enhancing ecommerce brands with ecommerce printing services, such as custom packaging, flyers, and product labels. Our solutions improve customer experience and build brand loyalty.",
          link: "#" },
    ];

    return (
        <div className="outer-who">
            <div className="container">
                <h2 className="text-center who-heading">Who We Serve</h2>
                <div className="row">
                    {industries.map((industry) => (
                        <div key={industry.id} className="col-md-4">
                            <a className="addlinks" href={industry.link}> {/* Make the whole area clickable */}
                                <div className="al-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="30" height="30">
                                        <defs>
                                            <linearGradient id="tickGradient" gradientTransform="rotate(45)">
                                                <stop offset="0%" stopColor="#63cec98a" />
                                                <stop offset="100%" stopColor="#eeb0f699" />
                                            </linearGradient>
                                        </defs>
                                        <circle cx="50" cy="50" r="50" fill="url(#tickGradient)" />
                                        <path
                                            d="M30 50 L45 65 L70 35"
                                            stroke="white"
                                            strokeWidth="8"
                                            fill="none"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    <h5 className="industries-heading">{industry.industries}</h5>
                                </div>
                                <p className="industries-para">{industry.Description}</p>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
